import ImageLogoNooioLight from '../../assets/logo-nooio-light.svg';
import ImageLogoNooioBlack from '../../assets/logo-nooio-black.svg';

import { FooterContainer } from './styles';

function Footer() {
  return (
    <FooterContainer>
      <div className="content">
          <div className="grid-footer">
            <div className="box-footer">
              <h2>Institucional</h2>

              <ul>
                <li><a href="#link">Início</a></li>
                <li><a href="#link">Sobre o Nooio</a></li>
                <li><a href="#link">Nosso time</a></li>
                <li><a href="#link">Nossos clientes</a></li>
                <li><a href="#link">Carreiras</a></li>
                <li><a href="#link">Segurança</a></li>
              </ul>
            </div>
            <div className="box-footer">
              <h2>Produtos</h2>

              <ul>
                <li><a href="#link">Minisite Delivery</a></li>
                <li><a href="#link">Smart Click</a></li>
                <li><a href="#link">Nooio Ads</a></li>
                <li><a href="#link">FoodMarket</a></li>
                <li><a href="#link">Nooio Search</a></li>
                <li><a href="#link">Blog</a></li>
              </ul>
            </div>
            <div className="box-footer">
              <h2>Atendimento</h2>

              <ul>
                <li><a href="#link">F.A.Q</a></li>
                <li><a href="#link">Whatsapp</a></li>
                <li><a href="#link">Messenger</a></li>
                <li><a href="#link">E-mail</a></li>
                <li><a href="#link">Telefone</a></li>
              </ul>
            </div>
            <div className="brand">
              <img src={ImageLogoNooioBlack} alt="Marketplace Nooio" />
              <p>Encontre diversas maneiras <br />de matar sua fome.</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="content">
            <div className="copyright">
              <img src={ImageLogoNooioLight} alt="Marketplace Nooio" />
              <span> &copy; 2021 Nooio - Todos os direitos reservados </span>
              <span><strong>CNPJ:</strong> 37.009.518/0001-04</span>
            </div>

            <div className="social">
              <h3>Siga-nós nas nossa redes sociais</h3>

              <div className="social-links">
                <a href="#social" target="_blank" rel="noreferrer noopener">
                  <i className="fab fa-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/nooio_oficial/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#social" target="_blank" rel="noreferrer noopener">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#social" target="_blank" rel="noreferrer noopener">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCWLtTkF1MOZJAAP6OBXzMgg"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
    </FooterContainer>
  );
};

export default Footer;
